import React, { Component, ReactFragment, ReactNode } from "react";
import { Badge, Slider } from "@jelly/ui";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { chartAOptions } from "./Lesson0305c.chart_a.config";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { chartBOptions } from "./Lesson0305c.chart_b.config";
import LessonChartA from "./Lesson0305c.chart_a";
import LessonChartB from "./Lesson0305c.chart_b";
import npyjs from "npyjs";

class Lesson0305c extends Component {
  //Numpy in js
  npy = new npyjs();
  xLabels = Array.from({ length: 300 }, (_, i) => -2 + (i * 4) / 299);

  state = {
    t: 0.8,
    t_stable: 0.8,
    n: 50,
    n_stable: 50,
  };

  /**
   * Adjust sliders config to fit Python
   */
  private sliders = {
    n: {
      name: "N",
      min: 30,
      max: 100,
      step: 5,
    },
    t: {
      name: "T",
      min: 0.8,
      max: 10,
      step: 0.4,
    },
  };

  updateParams = (key: string, value: number): void => {
    this.setState({ [key]: value });
  };
  updateParamsAfter = (key: string, value: number): void => {
    this.setState({ [key]: value });
  };

  renderParamSlider = (key: "t" | "n"): ReactFragment => {
    const property = this.state[key];
    const config = this.sliders[key];
    return (
      <div style={{ display: "flex", flex: "1 1 48%", alignItems: "center", gap: "0em", paddingRight: "1em" }}>
        <div style={{ flex: "0", minWidth: "6em" }}>
          <Badge theme="secondary" size="small">
            {`${config.name} = ${property.toFixed(2)}`}
          </Badge>
        </div>
        <div style={{ flex: "1" }}>
          <Slider
            min={config.min}
            max={config.max}
            step={config.step}
            theme="primary"
            value={property}
            onChange={(value) => {
              this.updateParams(key, value);
            }}
            onAfterChange={(value) => {
              this.updateParamsAfter(`${key}_stable`, value);
            }}
          />
        </div>
      </div>
    );
  };

  render(): ReactNode {
    const { t, n } = this.state;

    return (
      <div style={{ display: "flex", flexDirection: "column", height: "100%", flex: "1" }}>
        <div
          style={{
            flex: "1 0 80%",
            display: "flex",
            justifyContent: "space-evenly",
            gap: "1em",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <LessonChartA t={t} n={n} options={chartAOptions} />

          <LessonChartB t={t} n={n} options={chartBOptions} />
        </div>
        <div style={{ flex: "0 1", width: "100%" }}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "1em" }}>{this.renderParamSlider("t")}</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "1em" }}>{this.renderParamSlider("n")}</div>
        </div>
      </div>
    );
  }
}
//
export default Lesson0305c;
